import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CategoryResponse } from 'src/app/core/models/categories/category-response';
import { PageResponseCategoryResponse } from 'src/app/core/models/products/page-response-category-response';
import { PageResponseProductRS } from 'src/app/core/models/products/page-response-product-rs';
import { ProductRS } from 'src/app/core/models/products/product-rs';
import { PropertyFilter } from 'src/app/core/models/store-templates/property-filter';
import { TemplateNavigation } from 'src/app/core/models/store-templates/template-navigation';
import { TemplatePagesSelection } from 'src/app/core/models/store-templates/template-pages-selection';
import { Section } from 'src/app/core/models/store-templates/template-section';
import { CategoryService } from 'src/app/core/services/api/category.service';
import { ProductService } from 'src/app/core/services/api/product.service';
import { TooltipLabelTranslationService } from 'src/app/core/services/template/tooltip-label-translation.service';
import { forkJoin, Observable, of } from 'rxjs';


@Component({
  selector: 'app-dynamic-property-filter-by',
  templateUrl: './dynamic-property-filter-by.component.html',
  styleUrls: ['./dynamic-property-filter-by.component.scss']
})
export class DynamicPropertyFilterByComponent implements OnInit, OnChanges{
  
  @Input() filterObject:PropertyFilter;
  @Input() targetObject?:TemplateNavigation.TargetEnum;
  @Input() typeFilter?:Section.TypeEnum;
  @Input() showFilterBy:boolean = true;
  @Input() siteId:string;
  @Input() menuProposit:boolean = false;
  @Input() translations: any; // Objet des traductions du template

  @Output() onDataFilterChange = new EventEmitter<string>();
  

  pageProductsResponse: PageResponseProductRS;
  pageCategoriesResponse: PageResponseCategoryResponse;
  availableCategories: CategoryResponse[];
  selectedCategories: CategoryResponse[] = [];
  availableProducts: ProductRS[];
  selectedProducts: ProductRS[] = [];
  CategoryResponse: CategoryResponse = {};
  productResponse: ProductRS = {};

  filterByList:TemplatePagesSelection[];

  selectedItems:any[] = [];
  oneSelectedItem:any = {};
  availableItems: any[] = [];

  keySearch:string = "";
  bindLabelString:string = "";

  enableSave:boolean = true;
  initFilterDataSelect:boolean = false;
  
  isSingleItemMode: boolean = true;
    
  constructor(
    private productService: ProductService,
    private categoryService: CategoryService,
    private tooltipService: TooltipLabelTranslationService
  ) {
    
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
   // console.log("on init input filter compoenent ");
    // If by is empty or invalid and we have a targetObject, set a default value
    if ((!this.filterObject.by || (this.filterObject.by as any) === "") && this.targetObject) {
      if (this.targetObject === TemplateNavigation.TargetEnum.PDP) {
        this.filterObject.by = PropertyFilter.TypeEnum.PRODUCT_ID;
      } else if (this.targetObject === TemplateNavigation.TargetEnum.PLP) {
        this.filterObject.by = PropertyFilter.TypeEnum.PRODUCT_IDS;
      }
    }
    
    this.getBindLabel();
    this.initSearch();
    this.initElem();
    this.initFilterItem();
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.isDataReady = false;
    // If by is empty or invalid and we have a targetObject, set a default value
    if ((!this.filterObject.by || (this.filterObject.by as any) === "") && this.targetObject) {
      if (this.targetObject === TemplateNavigation.TargetEnum.PDP) {
        this.filterObject.by = PropertyFilter.TypeEnum.PRODUCT_ID;
      } else if (this.targetObject === TemplateNavigation.TargetEnum.PLP) {
        this.filterObject.by = PropertyFilter.TypeEnum.PRODUCT_IDS;
      }
    }
    this.getBindLabel();
    this.initElem();
    this.initSearch();
    this.initFilterItem();
    // This will run every time the targetObject input changes.
    if (changes['targetObject']) {
    this.isSingleItemMode = (this.targetObject === 'PDP');
    console.log("targetObject value: ", this.targetObject);
    }
  }

  onListsChanged(event: { itemsList: any[], selectedItems: any[] }) {
    // D'abord, on met à jour les listes locales comme avant
    if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
      this.availableCategories = event.itemsList ;
      this.selectedCategories = event.selectedItems ;
    } else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      this.availableProducts = event.itemsList ;
      this.selectedProducts = event.selectedItems ;
    }

    // ENSUITE, ON MET À JOUR L'ORDRE DES IDs DANS filterObject.data
    // C'est cette étape qui sauvegarde le nouvel ordre.
    // On vide l'ancien tableau d'IDs et on le remplit avec le nouvel ordre.
    this.filterObject.data = (event.selectedItems)
      .filter(item => item && item.id !== undefined && item.id !== null && item.id !== '')
      .map(item => item.id);
    
    // Only emit if we have both a filter type and actual data selected
    if (this.shouldEmitChange()) {
      this.onDataFilterChange.emit();
    }
  }

  // Method to check if we should emit changes to prevent unnecessary backend calls
  shouldEmitChange(): boolean {
    // Don't emit if filterObject or its properties are not properly set
    if (!this.filterObject || !this.filterObject.by) {
      return false;
    }

    // Don't emit if no data is selected
    if (!this.filterObject.data || this.filterObject.data.length === 0) {
      return false;
    }

    return true;
  }

  getMultiple(){
    return this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS;
  }

  getBindLabel(){
    if(this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      this.bindLabelString =  'title';
    }
    else //f(this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID){
    {  
      this.bindLabelString = 'default_label';
    }
  }

  initElem(){
    this.filterByList = [];
   // console.log("on init filter elem after target chagnge");
    if(this.targetObject){
      if(this.targetObject == TemplateNavigation.TargetEnum.PDP)
      {
        this.filterByList.push({key:PropertyFilter.TypeEnum.PRODUCT_ID, label:"Product"});
      }
      else if(this.targetObject == TemplateNavigation.TargetEnum.PLP){
          this.filterByList.push({key:PropertyFilter.TypeEnum.PRODUCT_IDS, label:"Products"});
          this.filterByList.push({key:PropertyFilter.TypeEnum.CATEGORY_IDS, label:"Categories"});
      }
    }

    if(this.typeFilter == Section.TypeEnum.PRODUCTS){
      this.filterByList.push({key:PropertyFilter.TypeEnum.CATEGORY_IDS, label:"Categories"});
      this.filterByList.push({key:PropertyFilter.TypeEnum.PRODUCT_IDS, label:"Products"});
    }
    else if(this.typeFilter == Section.TypeEnum.CATEGORIES){
      this.filterByList.push({key:PropertyFilter.TypeEnum.CATEGORY_IDS, label:"Categories"});
      this.filterByList.push({key:PropertyFilter.TypeEnum.PARENT_ID, label:"Parent Category"});
    }
    
  }

  initSearch() {
    if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
      this.searchCategory();
      this.keySearch = "default_label";
    } else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      this.searchProduct();
      this.keySearch = "title";
    }
  }

  initFilterItem() {
  

  if (!this.filterObject.data || this.filterObject.data.length === 0) {
    this.selectedProducts = [];
    this.selectedCategories = [];
    this.oneSelectedItem = null; // S'assurer que le modèle est vide aussi
    return;
  }

  // --- Logique pour les PRODUITS ---
  if (this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_ID) {
    const productObservables: Observable<ProductRS>[] = this.filterObject.data.map(id => this.productService.getProductById(id));
    
    forkJoin(productObservables).subscribe((products: ProductRS[]) => {
      this.selectedProducts = this.filterObject.data
        .map(id => products.find(p => p.id === id))
        .filter(p => p);

      // Si on est en mode sélection unique, on met à jour le modèle du sélecteur.
      if (!this.getMultiple() && this.selectedProducts.length > 0) {
        this.oneSelectedItem = this.selectedProducts[0];
      }
      else {
        // For multi-select, assign the full array to the ngModel
        this.selectedItems = this.selectedProducts;
      }
    });
  } 
  // --- Logique pour les CATÉGORIES ---
  else if (this.filterObject.by === PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PARENT_ID) {
    const categoryObservables: Observable<CategoryResponse>[] = this.filterObject.data.map(id => this.getCategoryById(id));

    forkJoin(categoryObservables).subscribe((categories: CategoryResponse[]) => {
      this.selectedCategories = this.filterObject.data
        .map(id => categories.find(c => c.id === id))
        .filter(c => c);

      // Si on est en mode sélection unique, on met à jour le modèle du sélecteur.
      if (!this.getMultiple() && this.selectedCategories.length > 0) {
        this.oneSelectedItem = this.selectedCategories[0];
      }
      else {
        // For multi-select, assign the full array to the ngModel
        this.selectedItems = this.selectedCategories;
      }
    });
  }
}

    

  onSelectFilterBy(event){
    
    this.filterObject.by = event.key; 
    this.filterObject.data = [];
    this.selectedCategories = [];
    this.selectedProducts = [];
    this.selectedItems = [];
    this.oneSelectedItem = null;
    this.getBindLabel();
    this.initSearch();
    this.initFilterItem();
  }
  
  getAvailableItems() {
  if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
    
    // On retourne uniquement les catégories qui ne sont PAS dans la liste des sélectionnées.
    return this.availableCategories.filter(cat => 
      !this.selectedCategories.some(selectedCat => selectedCat.id === cat.id)
    );

  } 
  else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
    
    // On retourne uniquement les produits qui ne sont PAS dans la liste des sélectionnés.
    return this.availableProducts.filter(prod => 
      !this.selectedProducts.some(selectedProd => selectedProd.id === prod.id)
    );

  } 
  else {
    return [];
  }
}
  getSelectedItems(){
    if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
      return this.selectedCategories;
    } else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      // Toujours retourner tous les produits sélectionnés, sans filtrer
      return this.selectedProducts;
    }
    return [];
  }

  searchCategory(searchBy: string = "") {
    this.pageCategoriesResponse = {};
    this.availableCategories = [];
    this.categoryService.searchCategories(this.siteId, searchBy).subscribe(
      (res) => {
        this.pageCategoriesResponse = JSON.parse(JSON.stringify(res));
        if (this.pageCategoriesResponse) {
          for (
            let index = 0;
            index < this.pageCategoriesResponse.content.length;
            index++
          ) {
            if (
              !this.availableCategories.find(
                (x) => x.id === this.pageCategoriesResponse.content[index].id
              )
            ) {
              this.availableCategories = [...this.availableCategories, this.pageCategoriesResponse.content[index]]
              /*this.availableCategories.push(
                this.pageCategoriesResponse.content[index]
              );*/
            }
          }
          this.availableItems = this.availableCategories;
          
          console.log(this.availableItems);
          this.availableItems.slice();
        }
        
      },
      (error) => {
        console.log("search category error: ");
        console.log(error);
      }
    );
  }

  setSelectedId(type:string){
    if (type == PropertyFilter.TypeEnum.CATEGORY_IDS || type == PropertyFilter.TypeEnum.PARENT_ID) {
      if(type == PropertyFilter.TypeEnum.CATEGORY_IDS){
        for (let index = 0; index < this.selectedCategories.length; index++) {
          if(  !this.selectedItems.find(
            (x) => x.id === this.selectedCategories[index].id )){
            //this.selectedItems.push(this.selectedCategories[index].id)
            this.selectedItems = [...this.selectedItems, this.selectedCategories[index]];
          }
        }
      }
      else{
        this.oneSelectedItem = this.selectedCategories[0]
        
      }
      
     // this.selectedItems.slice();

    }
    else{
      if(type == PropertyFilter.TypeEnum.PRODUCT_IDS){
        for (let index = 0; index < this.selectedProducts.length; index++) {
          if(  !this.selectedItems.find(
            (x) => x.id === this.selectedProducts[index].id )){
            //this.selectedItems.push(this.selectedProducts[index].id);
            this.selectedItems = [...this.selectedItems, this.selectedProducts[index]];
          }
          
        }
      }
      else{
        this.oneSelectedItem = this.selectedProducts[0]
      }
      
      //this.selectedItems.slice();
      
    }

    //console.log("on set selected items ");
    //console.log(this.oneSelectedItem);
  }


 
  searchProduct(value: string = "") {
    this.availableProducts = [];
    this.productService.searchProduct(this.siteId, value,[],"","").subscribe(
      (res) => {
        this.pageProductsResponse = JSON.parse(JSON.stringify(res));
        //console.log( this.pageProductsResponse);
        for (
          let index = 0;
          index < this.pageProductsResponse.content.length;
          index++
        ) {
          if (
            !this.availableProducts.find(
              (x) => x.id === this.pageProductsResponse.content[index].id
            )
          )
          this.availableProducts = [...this.availableProducts, this.pageProductsResponse.content[index]]
          //this.availableProducts = this.pageProductsResponse.content;
        }
        this.availableItems = this.availableProducts;
   
        //console.log(this.availableItems);
        this.availableItems.slice();
      },
      (error) => {
        console.log("search product error: ");
        console.log(error);
      }
    );
  }

    // Assurez-vous que getProductById ne fait que retourner un Observable
  getProductById(id: string): Observable<ProductRS> {
    if (id) {
      return this.productService.getProductById(id);
    } else {
      return of(null);
    }
  }

  // AJOUTEZ CETTE NOUVELLE MÉTHODE pour les catégories
  getCategoryById(id: string): Observable<CategoryResponse> {
    if (id) {
      return this.categoryService.getCategoryById(id);
    } else {
      return of(null);
    }
  }


  onSearchAction(event){

    console.log("on search actions");
    console.log(event);

    if (this.filterObject.by == PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PARENT_ID) {
      console.log("on search actions");
      this.searchCategory(event);

    // CORRIGEZ CETTE LIGNE : remplacez 'Type_enum' par 'TypeEnum'
    } else if (this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by == PropertyFilter.TypeEnum.PRODUCT_ID) {
      console.log("on search actions");
      this.searchProduct(event);

    }
  }

  onSelectSearchAction(text: string) {
    console.log(this.selectedCategories);
    
    if (this.filterObject.by === PropertyFilter.TypeEnum.CATEGORY_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PARENT_ID) {
      // Search in avafilableCategories to find the selected item
      const selectedItem = this.selectedCategories.find(item => item.default_label.includes(text));
      // If the item is found and it's not already in the selectedCategories array, add it
      if (selectedItem && !this.selectedCategories.some(item => item.default_label.includes(text))) {
        this.selectedCategories.push(selectedItem); 
      }
      console.log(this.selectedCategories);
    } else if (this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_ID) {
      // Similar logic for products
      const selectedItem = this.availableProducts.find(item => item.slug.includes(text));
      if (selectedItem && !this.selectedProducts.some(item => item.slug.includes(text))) {
        this.selectedProducts.push(selectedItem);
      }
    }
  
    // If you need to handle additional types, you can add more conditions here

    // After updating the selected items, you might want to update the parent component or perform other actions
    // For example, you could emit an event to the parent component to inform it about the selection change
  }

  updatedataFilter(event: any = null) {
    // Si event est undefined/null (appel programmatique), ne rien faire
    if (event === undefined || event === null) {
      return;
    }
    console.log("on select category o product event ");
    console.log(event);

    if (!this.getMultiple()) {
      this.filterObject.data = [];
      if (event && event.id !== undefined && event.id !== null && event.id !== '') {
        this.filterObject.data.push(event.id);
        this.oneSelectedItem = event; // Mettre à jour le modèle avec l'objet complet
      } else {
          this.oneSelectedItem = null; // Vider le modèle si la sélection est effacée
        }
      // Merge selectedProducts with availableProducts to keep all selected
      if (this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_ID) {
        const allProducts = [...this.selectedProducts, ...this.availableProducts];
        this.selectedProducts = allProducts.filter((prod, idx, arr) =>
          this.filterObject.data.includes(prod.id) && arr.findIndex(p => p.id === prod.id) === idx
        );
      }
      // Only emit if we have valid data to save
      if (this.shouldEmitChange()) {
        this.onDataFilterChange.emit();
      }
    } else {
      if (Array.isArray(event) && event.length > 0) {
        this.filterObject.data = [];
        event.forEach(item => {
          if (item && item.id !== undefined && item.id !== null && item.id !== '') {
            if (this.filterObject.data.indexOf(item.id) == -1) {
              this.filterObject.data.push(item.id);
            }
          }
        });
        // Merge selectedProducts with availableProducts to keep all selected
        if (this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_IDS || this.filterObject.by === PropertyFilter.TypeEnum.PRODUCT_ID) {
          const allProducts = [...this.selectedProducts, ...this.availableProducts];
          this.selectedProducts = allProducts.filter((prod, idx, arr) =>
            this.filterObject.data.includes(prod.id) && arr.findIndex(p => p.id === prod.id) === idx
          );
        }
        // Only emit if we have valid data to save
        if (this.shouldEmitChange()) {
          //this.onDataFilterChange.emit();
        }
      } else if (Array.isArray(event) && event.length === 0) {
        // Handle empty array case - clear data but don't emit to avoid backend errors
        this.filterObject.data = [];
        // Don't emit here as empty data shouldn't trigger save
      }
    }
  }

  onCloseMenu(event){
    if(this.getMultiple() && this.shouldEmitChange()){
      this.onDataFilterChange.emit();
    }
  }

  // Handle image loading errors - mark item to show placeholder
  onImageError(item: any): void {
    if (item) {
      item._imageError = true;
    }
  }

  // Récupère le tooltip du filtre
  getFilterTooltip(): string | null {
    if (!this.translations || !this.filterObject) {
      return null;
    }
    const tooltipId = this.tooltipService.findTooltipId(this.filterObject);
    if (!tooltipId) {
      return null;
    }
    return this.tooltipService.getTooltipText(tooltipId, this.translations);
  }

  // Récupère le label traduit du filtre
  getFilterLabel(): string {
    if (this.translations && this.filterObject) {
      const labelId = this.tooltipService.findLabelId(this.filterObject);
      if (labelId) {
        const translated = this.tooltipService.getLabelText(labelId, this.translations);
        if (translated) {
          return translated;
        }
      }
    }
    return this.filterObject?.label || 'Filter';
  }

  
}
